import { cn } from '@/lib/utils'

interface BulbIconProps {
  className?: string
}

export function BulbIcon({ className }: BulbIconProps): React.ReactElement {
  return (
    <svg
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-6', className)}
    >
      <path
        d="M16.0899 2.82001C15.1702 2.06359 14.0933 1.52204 12.9376 1.23485C11.7819 0.947666 10.5767 0.922096 9.40994 1.16001C7.85632 1.47383 6.43093 2.24208 5.31462 3.36729C4.19832 4.49249 3.44141 5.92394 3.13994 7.48001C2.91979 8.64673 2.95979 9.84766 3.2571 10.9971C3.55441 12.1466 4.1017 13.2163 4.85994 14.13C5.56363 14.9241 5.96698 15.9395 5.99994 17V20C5.99994 20.7957 6.31601 21.5587 6.87862 22.1213C7.44123 22.6839 8.20429 23 8.99994 23H12.9999C13.7956 23 14.5587 22.6839 15.1213 22.1213C15.6839 21.5587 15.9999 20.7957 15.9999 20V17.19C16.0335 16.0192 16.4637 14.8944 17.2199 14C18.5451 12.3608 19.1697 10.2648 18.9581 8.16763C18.7465 6.07044 17.7158 4.14149 16.0899 2.80001V2.82001ZM13.9999 20C13.9999 20.2652 13.8946 20.5196 13.707 20.7071C13.5195 20.8947 13.2652 21 12.9999 21H8.99994C8.73473 21 8.48037 20.8947 8.29284 20.7071C8.1053 20.5196 7.99994 20.2652 7.99994 20V19H13.9999V20ZM15.6699 12.76C14.6644 13.9526 14.0778 15.442 13.9999 17H11.9999V14C11.9999 13.7348 11.8946 13.4804 11.707 13.2929C11.5195 13.1054 11.2652 13 10.9999 13C10.7347 13 10.4804 13.1054 10.2928 13.2929C10.1053 13.4804 9.99994 13.7348 9.99994 14V17H7.99994C7.97356 15.4681 7.40689 13.9948 6.39994 12.84C5.73558 12.044 5.28883 11.0894 5.10325 10.0694C4.91767 9.04928 4.99959 7.99852 5.34103 7.01954C5.68247 6.04055 6.27176 5.16675 7.05146 4.48333C7.83116 3.79992 8.77465 3.33021 9.78994 3.12001C10.6625 2.94035 11.5641 2.95725 12.4293 3.16948C13.2945 3.3817 14.1016 3.78393 14.792 4.34696C15.4824 4.90999 16.0387 5.61969 16.4206 6.42453C16.8025 7.22937 17.0004 8.10915 16.9999 9.00001C17.0073 10.3699 16.537 11.6995 15.6699 12.76Z"
        fill="currentColor"
      />
      <path
        d="M10 14C10 13.4477 10.4477 13 11 13C11.5523 13 12 13.4477 12 14V17H10V14Z"
        fill="var(--color-primary)"
      />
    </svg>
  )
}
